/**
 * Vocabulário de tela da Curva de Evasão (ADR-0019).
 *
 * Nada aqui calcula métrica (invariante 3): a Taxa chega pronta do servidor. Isto só escolhe
 * o TEXTO — e, principalmente, separa os três jeitos de não ter número: marco que ainda não
 * venceu ("ainda não deu tempo"), recorte sem entrada ("ninguém entrou") e amostra pequena
 * (há número, mas pouca gente para concluir). `0%` medido aparece como `0%`.
 */
import { formatCurrency, formatNumber, formatPercent, NO_DATA_DASH } from '@mgdlead/ui';

export interface TaxaLike {
  valor: number | null;
  vencidos: number;
  pendentes: number;
  eventos: number;
  amostraPequena: boolean;
}

/** O número, ou o travessão. */
export function taxaTexto(t: TaxaLike, casas = 0): string {
  return t.valor === null ? NO_DATA_DASH : formatPercent(t.valor, casas);
}

/** Por que não há número, em português — para o tooltip do travessão. */
export function motivoSemTaxa(t: TaxaLike): string | null {
  if (t.valor !== null) return null;
  if (t.pendentes > 0) {
    return `Ainda não deu tempo: ${formatNumber(t.pendentes)} ${
      t.pendentes === 1 ? 'pessoa ainda não completou' : 'pessoas ainda não completaram'
    } este marco.`;
  }
  return 'Ninguém entrou no período para medir.';
}

/** "Pouca gente para tirar conclusão (12 pessoas)." — `null` quando a amostra basta. */
export function avisoDeAmostra(t: TaxaLike): string | null {
  return t.amostraPequena
    ? `Pouca gente para tirar conclusão (${formatNumber(t.vencidos)} ${
        t.vencidos === 1 ? 'pessoa' : 'pessoas'
      }).`
    : null;
}

export function centavosTexto(centavos: number | null, moeda: string | null = 'BRL'): string {
  return centavos === null ? NO_DATA_DASH : formatCurrency(centavos / 100, moeda ?? 'BRL');
}

export const ROTULO_DO_RECORTE = {
  WORKSPACE: 'Todo o workspace',
  SEM_ATRIBUICAO: 'Sem atribuição',
} as const;

export const TOOLTIP_D1_X_24H =
  'Evasão 1º dia é por CALENDÁRIO: quem saiu até o fim do dia seguinte ao da entrada. "Ficaram 24h" é janela de RELÓGIO: 24 horas a partir da entrada. Por isso os dois podem diferir.';

export const LEGENDA_DO_CARD =
  'Conta só quem saiu por conta própria: quem você removeu fica fora da conta.';
